import React, { useEffect } from 'react';
import '../css/userAgreement.css';
import Header from "../components/header/Header"
import Footer from "../components/footer/Footer"
import JoinUs from "../components/JoinUs"
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft} from '@fortawesome/free-solid-svg-icons'
import $ from 'jquery';
//import { useSearchParams } from "react-router-dom";

const MyeKukka = props => {
  useEffect(() => {
    controlHistory()
    $('body').css('background', '#fff');
  }, [])
  const navigate = useNavigate();
  //const [searchParams, setSearchParams] = useSearchParams();
  const queryParameters = new URLSearchParams(window.location.search)
  function controlHistory() {
    window.onpopstate = function (event) {
      var page = 'signIn';
      if (document.location.hash.substring(1) !== '') {
        page = document.location.hash.substring(1);
      }
    }
  }
  const navigateSignIn = () => {
    if (queryParameters.get("ref") == 'shop'){
      props.backToShop()
      return;
    }
    navigate('/#signIn');
  };

  /*
   const navigateSignUp = () => {
    navigate('/#signUp');
  };
  */

  const getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  let clientId = "4inkkk5uo5ef4foec6enqofo0v";
  let lastAuthUser = getCookie("CognitoIdentityServiceProvider."+ clientId +".LastAuthUser");
  let user = getCookie("CognitoIdentityServiceProvider."+ clientId +"."+ lastAuthUser +".userData");

  return(
    <div>
      <Header/>
        <div className="header_nav_container">
          <div className="go_back_div" onClick={navigateSignIn}><FontAwesomeIcon className="chevronLeft" icon={faChevronLeft} size="1x" /> <span className="textUnderline">Palaa takaisin</span></div>
          { user !== "" || user !== "undefined" && <div className="signIn_link_text"><span id="already_user">Oletko jo jäsen?</span> <span className="sign_link" onClick={navigateSignIn}>Kirjaudu sisään</span></div>}
        </div>
        <div className="page_container_agreement">
            <h2>Oma eKukka -käyttöehdot</h2>

            <h3>JOHDANTO</h3>
            <p>Tervetuloa Oma eKukka -jäseneksi. eKukka.fi on kotimainen ja luotettava palvelu, jonka kautta voi ostaa kukkia itselle tai toiselle. Rekisteröitymällä hyväksyt seuraavat ehdot. Palvelua ylläpitää Floweb Oy, y-tunnus: 2485800-1, osoite: Tervastie 28, 90650 Oulu.</p>

            <h3>JÄSENYYS</h3>
            <p>
              Liittymällä Oma eKukan jäseneksi teet kukkien tilaamisesta entistä helpompaa. Saat mieltymyksesi ja valintojesi mukaista mainontaa ja viestintää. Voit halutessasi kieltää eKukalta tulevan kohdennetun markkinoinnin ja asiakasviestinnän. Voit tarkastella aiempia tilauksia myöhemmin kohdasta “Omat tilaukset” ja sähköiset kuitit löytyvät kätevästi samasta paikasta.
              Tallennamme tuotteet ostoskoriin, kun olet sisäänkirjautuneena. Voit vaihtaa laitetta välissä ja säilytämme ostoskorisi sisällön tällöin. Muistutamme sinua keskeneräisestä ostoskorista sähköpostitse. Ostoskoriin tallennettuja tuotteita ei voida varata sinulle, vaan ne saatetaan myydä loppuun ostamisen aikana. Olethan siis nopea ostoksissasi.
            </p>

            <ol>

              <li>Jäsenyyteen ei sisälly ostopakkoa ja se on maksuton. </li>
              <li>Nopeuta kukkien tilaamista tallentamalla omat yhteystietosi. </li>
              <li>Seuraa tilauksesi valmistumisen vaiheita. </li>
              <li>Löydä helposti aiemmat tilauksesi ja niiden kuitit. </li>
              <li>Inspiroidu ammattilaisten kukkavinkeistä tilaamalla Kukkaystävät-uutiskirje ja koeta onneasi osallistumalla mahdollisiin arvontoihin.</li>
            </ol>

            <p>
              Jäsenyys on tarkoitettu yksityishenkilöille. Jotta voit liittyä Oma eKukan -jäseneksi, sinun tulee olla vähintään 18-vuotias.
              Voit liittyä jäseneksi ainoastaan eKukan Oma eKukka -verkkosivuilla. Kirjautuakseen palveluun sisään, täytyy henkilöllä olla voimassa oleva sähköpostitili.
            </p>

            <p>
              Jäsenyys on henkilökohtainen, eikä siirrettävissä toiselle. Jäsenen velvollisuus on pitää yhteystiedot ajan tasalla. Olet jäsenenä vastuussa kaikkeen toimintaan, joka tapahtuu jäsentilisi kautta. Käytä sähköpostia ja salasanaa kirjautuessasi siten, että ne säilyvät omana tietonasi. Jos salasanasi päätyy toisen henkilön tietoon, vaihda salasanasi.
            </p>

            <p>
              Voit muokata tietojasi, päivittää asetuksiasi tai peruuttaa jäsenyytesi milloin tahansa Oma eKukassa kohdassa Omat tiedot.
              eKukka käsittelee henkilötietojasi tietosuojakäytäntöjen mukaisesti. Lisätietoja voit lukea: https://ekukka.fi/cookies_setting.php
            </p>



            <p>
              eKukka ilmoittaa sähköpostitse, jos se tuo uusia palveluja markkinoille, muokkaa Oma eKukkaa merkittävästi tai sen jäsenehtoja, keskeyttää, rajoittaa, lopettaa Oma eKukan tai sovellettavissa laeissa tulee muutoksia. Ilmoitetut muutokset tulevat voimaan 14 arkipäivän kuluttua ensimmäisestä sähköpostilla lähetetystä ilmoituksesta. Voit peruuttaa jäsenyytesi, mikäli et halua hyväksyä muutoksia. Ehdot tulee tarkastaa säännöllisesti, sillä eKukka voi tehdä pieniä muutoksia Oma eKukkaan tai sen ehtoihin ilmoittamatta etukäteen. Tällaiset muutokset eivät saa vaikuttaa jäsenyyteen negatiivisesti merkittävällä tavalla.
            </p>

            <p>
            Jos Oma eKukkaa käyttää väärin, kuten ei noudata ehtoja, tekee todennäköisesti tai todistetusti petoksen, rikkoo sääntöjä, antaa virheellisiä tietoja, on passiivinen tilin käytössä tai vahingoittaa jollain tavoin eKukan etuja, voidaan jäsenyys rajoittaa tai irtisanoa välittömästi.
            </p>

            <p>
              Samalla henkilöllä ei saa olla useampia tilejä tai jos jäsen on irtisanottu ja käyttäjä on tehnyt uuden tilin, voidaan jäsenyyttä rajoittaa tai lopettaa pääsy Oma eKukkaan. Ota yhteyttä asiakaspalveluun, jos epäilet eKukan tehneen virheen ja pääsysi Oma eKukkaan on evätty syyttä tai tilauksesi on peruttu syyttä.
            </p>


            <p>
              eKukka ei vastaa Oma eKukan toiminta- ja järjestelmähäiriöistä tai niistä johtuvista mahdollisista seurauksista. Lukuun ottamatta lakisääteistä vastuuta, eKukka ei vastaa vahingoista tai tappioista, jotka johtuvat Oma eKukan muutoksista, keskeytyksestä, lakkautuksesta tai muista tapahtumista, jotka liittyvät lakkauttamiseen.
            </p>

            <p>
              Näihin ehtoihin sovelletaan Suomen lakia. Riitatapauksissa pyritään sopu löytämään neuvottelulla. Jos neuvotteluissa ei päästä sopuun, erimielisyydet ratkaistaan suomalaisessa oikeusistunnossa.

            </p>

            <p>
              Mikäli sopimusehdoissa tulee muutoksia ja yksittäinen sopimusehto ei pädekään, eivät tällöin muut sopimusvelvoitteet lakkaa. Pätemätön tai kelvoton ehto pyritään korvaamaan mahdollisimman pian käyttökelpoisella tai pätevällä ehdolla.
            </p>

            <h3>YLIVOIMAINEN ESTE</h3>
            <p>
              eKukka ei ole korvausvastuussa menetyksistä, jotka johtuvat lakoista, sotatoimista, boikoteista, oikeustoimista, työsuluista, julkisten viranomaisten toimenpiteistä, kauppasaarroista tai muista vastaavista tapahtumista. Jos eKukka ryhtyisi työsulkuun, lakkoon, boikottiin tai kauppasaartoon tai olisi itse edellä mainittujen kohteena, sovelletaan tällöin vastuuvapauslauseketta. Tilanteissa, joissa eKukka on noudattanut tavallista huolellisuutta, ei eKukka ole velvollinen maksamaan vahingonkorvauksia.
            </p>
            <p>
              Jos sinulla tulee kysyttävää Oma eKukasta, voit ottaa eKukan asiakaspalveluun yhteyttä sähköpostitse osoitteessa info@ekukka.fi
            </p>

            <div className="contact_container">
              <h3>YHTEYSTIEDOT</h3>
              <p>
              <strong>eKukan asiakaspalvelu</strong>
              <span className="platform_email">info@ekukka.fi</span>
              </p>

              <p>Päivitetty: 21.6.2022</p>
            </div>


            <JoinUs/>

        </div>
      <Footer/>
    </div>
  )
}
export default MyeKukka;
